import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { orpc } from '@/api/rpc/client';

/** The organization's Report color palettes, built-in first; one is the default. */
export function useReportColorPalettes() {
  return useQuery({
    ...orpc.reportColorPalettes.list.queryOptions({ input: {} }),
    // Palettes change rarely; every chart on a page shares one fetch.
    staleTime: 5 * 60_000,
  });
}

function useRefreshPalettes() {
  const queryClient = useQueryClient();
  return () =>
    queryClient.invalidateQueries({
      queryKey: orpc.reportColorPalettes.list.queryKey({ input: {} }),
    });
}

export function useCreateReportColorPalette() {
  const onSuccess = useRefreshPalettes();
  return useMutation(
    orpc.reportColorPalettes.create.mutationOptions({ onSuccess }),
  );
}

export function useUpdateReportColorPalette() {
  const onSuccess = useRefreshPalettes();
  return useMutation(
    orpc.reportColorPalettes.update.mutationOptions({ onSuccess }),
  );
}

export function useDeleteReportColorPalette() {
  const onSuccess = useRefreshPalettes();
  return useMutation(
    orpc.reportColorPalettes.delete.mutationOptions({ onSuccess }),
  );
}

export function useSetDefaultReportColorPalette() {
  const onSuccess = useRefreshPalettes();
  return useMutation(
    orpc.reportColorPalettes.setDefault.mutationOptions({ onSuccess }),
  );
}
